import React, {useEffect, useState} from 'react';
import {Bar} from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import {getSaleHistory, listSortRange, SortRange} from '@api/item';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Price_history = ({classes, id}: {classes: string; id?: number}) => {
  const [labels, setLabels] = useState<string[]>([]);
  const [data, setData] = useState<number[]>([]);
  const [selectRange, setSelectRange] = useState<SortRange>(listSortRange[0]);
  const [volume, setVolume] = useState<number>(0);

  useEffect(() => {
    if (id) {
      getSaleHistory({id: id, range: selectRange}).then((res) => {
        const {records, totalVolume, totalVolumePrevious, percentChanges} = res;
        setVolume(Number(totalVolume));
        if (Array.isArray(records)) {
          setLabels(records.reverse().map((val) => val.date));
          setData(records.map((val) => Number(val.price[0])));
        } else {
          setLabels([]);
          setData([]);
          setVolume(0);
        }
      });
    }
  }, [id, selectRange]);

  return (
    <div className="relative mb-24 w-full">
      {/* <!-- Price History --> */}
      <div className="tab-pane fade">
        <div className={classes}>
          {/* <!-- Period / Stats --> */}
          <div className="mb-10 flex flex-wrap-reverse justify-between">
            <div className="py-2">
              <span className="inline-block align-middle">
                <span className="block text-sm font-bold dark:text-white">
                  {selectRange.replace('LAST_', '').replace('_', ' ')} Volume:
                </span>
                <span className="text-green block text-sm font-bold">
                  Ξ{volume.toLocaleString()}
                </span>
              </span>
            </div>
            <select
              onChange={(e) => setSelectRange(e.target.value as SortRange)}
              className="dark:bg-dark-navy dark:border-jacarta-600 border-jacarta-100 rounded-lg text-sm dark:text-white min-h-[12px]"
            >
              {listSortRange.map((val, index) => {
                return (
                  <option key={index} value={val}>
                    {val.replaceAll('_', ' ')}
                  </option>
                );
              })}
            </select>
          </div>

          {/* <!-- Chart --> */}
          <div className="chart-container relative h-80 w-full">
            <Bar
              data={{
                labels: labels,
                datasets: [
                  {
                    label: 'Avg. price',
                    backgroundColor: '#E7E8EC',
                    data: data,
                  },
                ],
              }}
              options={{
                maintainAspectRatio: false,
                responsive: true,
                interaction: {
                  intersect: false,
                  mode: 'index',
                },
                scales: {
                  x: {
                    grid: {
                      display: false,
                    },
                  },
                  y: {
                    ticks: {
                      stepSize: 50,
                    },
                  },
                },
                plugins: {
                  legend: {display: false},
                  decimation: {
                    enabled: true,
                  },
                  tooltip: {
                    usePointStyle: true,
                    position: 'nearest',
                    backgroundColor: '#131740',
                    titleAlign: 'center',
                    bodyAlign: 'center',
                    footerAlign: 'center',
                    padding: 12,
                    displayColors: false,
                    yAlign: 'bottom',
                  },
                },
                animation: false,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Price_history;
